import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Primitive Button component
 * Styled version of MUI Button that respects the theme
 */
const Button = ({ children, variant = 'contained', color = 'primary', ...props }) => {
  const theme = useTheme();

  return (
    <MuiButton
      variant={variant}
      color={color}
      {...props}
      sx={{
        ...props.sx,
      }}
    >
      {children}
    </MuiButton>
  );
};

export default Button;


